import {
  Box,
  Chip,
  FormControl,
  InputLabel,
  LinearProgress,
  MenuItem,
  Select,
} from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { modelsLabelsList as defaultModelsList } from "../constants";
import { hostname } from "../utils";
import { isFreeUser } from "../utils/subscriptionUtils";

export default ({
  currentPlan,
  value,
  onChange,
  tools = false,
  sx = { mt: 2 },
  companyId,
}: {
  currentPlan: string;
  value: string;
  onChange: (event: any) => void;
  tools: boolean;
  sx?: any;
  companyId?: string;
}) => {
  const [models, setModels] = useState(defaultModelsList);
  const [loading, setLoading] = useState(false);

  // Fetch models from backend API
  useEffect(() => {
    const fetchModels = async () => {
      setLoading(true);
      try {
        const params = companyId ? { companyId } : {};
        const response = await axios.get(`${hostname}/api/v0/models`, { params });
        if (response.data && response.data.models) {
          setModels(response.data.models);
        }
      } catch (error) {
        console.error("Error fetching models:", error);
        // Fallback to default models from constants if API fails
        setModels(defaultModelsList);
      } finally {
        setLoading(false);
      }
    };

    fetchModels();
  }, [companyId]);

  const filteredList = models.filter((x) => !isFreeUser(currentPlan) && x.free);

  return (
    <FormControl fullWidth sx={sx}>
      <InputLabel>Model</InputLabel>
      <Select
        label="Model"
        value={value || (filteredList.length > 0 ? filteredList[0].name : "")}
        onChange={onChange}
        disabled={loading}
      >
        {loading ? (
          <MenuItem disabled>
            <LinearProgress style={{ width: "100%" }} />
          </MenuItem>
        ) : (
          models.map((model) => (
            <MenuItem
              key={model.name}
              value={model.name}
              disabled={isFreeUser(currentPlan) && !model.free}
            >
              <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
                <Box sx={{ display: "flex", alignItems: "center", fontWeight: 600, fontSize: "1.05rem" }}>
                  {model.label}
                </Box>
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                  <Chip
                    label={model.provider}
                    size="small"
                    sx={{ height: "20px" }}
                  />
                  <Chip
                    label={model.credits + " credits"}
                    size="small"
                    sx={{ height: "20px" }}
                  />
                  {model.tags &&
                    model.tags.map((tag) => (
                      <Chip
                        key={tag}
                        label={tag}
                        size="small"
                        sx={{ height: "20px" }}
                      />
                    ))}
                </Box>
              </Box>
            </MenuItem>
          ))
        )}
      </Select>
    </FormControl>
  );
};
